import {
  FieldValues,
  RegisterOptions,
  Validate,
  ValidationValueMessage,
} from 'react-hook-form';
import { AemField } from '../../constants/types/AemTypes';

export type Validator = Validate<string, Record<string, string>>;
export type RequiredErrorMessage = ValidationValueMessage<boolean>;

export const generateRules = <T extends FieldValues>(
  field: AemField,
  validator?: Validator
): RegisterOptions<T> => {
  const { regEx, validationErrorMessage, requiredErrorMessage } = field;

  if (field.type === 'number' && regEx === undefined) {
    field.regEx = '^[0-9]*$';
  }

  const regexValidation =
    regEx && validationErrorMessage
      ? {
          pattern: {
            value: new RegExp(regEx),
            message: validationErrorMessage,
          },
        }
      : {};

  const required = requiredErrorMessage
    ? {
        required: {
          value: !!requiredErrorMessage,
          message: requiredErrorMessage,
        },
      }
    : {};

  const customValidator = {
    validate: validator,
  };

  const rules = {
    ...regexValidation,
    ...required,
    ...customValidator,
  };

  return rules;
};
